import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ConfigService } from './../common/services/config.service';
import { CommonConstants } from './../common/utilities/commonConstants';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { HomeService } from './home.service';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { SharedService } from './../common/services/sharedService';
import { Formatter } from './../common/services/formatter';
import { FormValidator } from '../common/services/formValidator.service';
import { EmitterService } from '../common/services/emitter.service';
@Component({
    selector: 'app-home',
    template: '',
    styleUrls: ['./home.style.css'],
    providers: [HomeService, HttpModule]
})
export class HomeComponent implements OnInit {
    private DateOfBirthErrorString: string;
    private _UTMDataObject: any;
    public flowType: string;
    private securedProductFlag = false;
    public FormValidator: FormValidator;
    public MobParam = '';
    public platformOStype: string = '';
    private src;
    private src_30;
    private src_60;
    private src_90;
    private pid;
    private prodCode;
    private uci;
    private emailUTMParameter;
    private emailUTMValue;
    constructor(
        private _homeService: HomeService,
        private _routeContextProvider: RouteContextProvider,
        private _cookieHandler: CookieHandlerService,
        private _sharedService: SharedService,
        private _http: HttpModule,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private _routerService: RouteHandlerService,
        private _formatter: Formatter,
        private formValidator: FormValidator,
        private _emitterService: EmitterService
    ) { this.FormValidator = formValidator; }
    public ngOnInit(): void {
        this.authenticateSystem();
        // this.storeDetailsToCookies();
    }
    private getbase64Encoded(rawStr) {
        let result;
        if (rawStr.substr(0, 3) === 'BFL' || rawStr.substr(0, 4) === '-' || rawStr.length === 10) {
            return rawStr;
        } else {
            result = atob(rawStr);
            return result;
        }
        // console.log('resule:::', result);
        // return result;
    }
    public setUtmTermVal() {
        let setUtmTerm;
        const UtmTermGA = this._cookieHandler.GetCookie('_ga').split('.');
        UtmTermGA.splice(0, 2);
        const UtmTermGALength = UtmTermGA.length;
        setUtmTerm = UtmTermGA[0];
        for (let i = 1; i < UtmTermGALength; i++) {
            if (i !== UtmTermGALength) {
                setUtmTerm = setUtmTerm + '.';
            }
            setUtmTerm = setUtmTerm + UtmTermGA[i];
            // console.log(setUtmTerm);
        }
        this._cookieHandler.SetCookie(CommonConstants.QueryParamsKeys.appUtmTerm,
            setUtmTerm);
        this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmTerm, setUtmTerm);
    }
    private ValidateAge(dob, productCode) {
        if (dob === '' || dob === undefined) {
            return false;
        }
        const SplitDob = dob.split('-');
        const DateOfBirth = {
            Day: SplitDob[2],
            Month: SplitDob[1],
            Year: SplitDob[0]
        };
        this.DateOfBirthErrorString = this.FormValidator
            .IsDateOfBirthValid(DateOfBirth, CommonConstants.SERVERDATE, CommonConstants.CommonGatewayDateRanges[productCode].MinAge,
                CommonConstants.CommonGatewayDateRanges[productCode].MaxAge);
        return (this.DateOfBirthErrorString === null) ? true : false;
        // if (isDateOfBirthValid && this.DateOfBirthErrorString == null) {
        // if (this.DateOfBirthErrorString == null) {
        //     this.InvalidDoB = false;
        //     this.notValidDOB = false;
        // } else {
        //     this.notValidDOB = true;
        //     this.InvalidDoB = true;
        // }
    }
    /*Start: Secured specific changes*/
    private setProductCodeInCookie(productCode) {
        const productObj = (CommonConstants.CodeMapper[productCode]) ? CommonConstants.CodeMapper[productCode] : { code: '' };
        this._cookieHandler.SetCookie(CommonConstants.QueryParamsKeys.Productcode, productObj.code);
        window.name = productObj.code;
        console.log(this._cookieHandler.GetCookie(CommonConstants.QueryParamsKeys.Productcode));
    }
    private checkProductCode() {
        const prdCode = this._cookieHandler.GetCookie(CommonConstants.QueryParamsKeys.Productcode);
        console.log('header product code', prdCode);
        if (prdCode === 'DHL' || prdCode === 'DHB' ||
            prdCode === 'DLAP' || prdCode === 'DLAPB') {
            this.securedProductFlag = true;
        }
    }
    /*End: Secured specific changes*/
    private PersistUTMParametersforEMailURL() {
        if (this.src !== '') {
            this.emailUTMValue = this.src;
            this.emailUTMParameter = CommonConstants.QueryParamsKeys.src;
        } else if (this.src_30 !== '') {
            this.emailUTMValue = this.src_30;
            this.emailUTMParameter = CommonConstants.QueryParamsKeys.src_30;
        } else if (this.src_60 !== '') {
            this.emailUTMValue = this.src_60;
            this.emailUTMParameter = CommonConstants.QueryParamsKeys.src_60;
        } else if (this.src_90 !== '') {
            this.emailUTMValue = this.src_90;
            this.emailUTMParameter = CommonConstants.QueryParamsKeys.src_90;
        } else if (this.pid !== '') {
            this.emailUTMValue = this.pid;
            this.emailUTMParameter = CommonConstants.QueryParamsKeys.pid;
        }
        this._sharedService.setData(CommonConstants.QueryParamsKeys.emailUTMParameter, this.emailUTMParameter);
        this._sharedService.setData(CommonConstants.QueryParamsKeys.emailUTMValue, this.emailUTMValue);

        /* changes added as part of - DIRUNSEC-2525 */
        if (this.emailUTMValue !== '' && this.emailUTMValue !== undefined) {
            const UTMSplitValue = this.emailUTMValue.split(':');
            if (UTMSplitValue.length === 6) {
                /* this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmSource,
                    this.emailUTMParameter === CommonConstants.QueryParamsKeys.pid ? UTMSplitValue[0] : UTMSplitValue[1]);
                this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmMedium,
                    this.emailUTMParameter === CommonConstants.QueryParamsKeys.pid ? UTMSplitValue[1] : UTMSplitValue[2]); */
                this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmSource, UTMSplitValue[1]);
                this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmMedium, UTMSplitValue[2]);
                this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmCampaign, UTMSplitValue[3]);
                this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmContent, UTMSplitValue[4]);
                this._sharedService.setData(CommonConstants.QueryParamsKeys.appUtmTerm, UTMSplitValue[5]);
                this._cookieHandler.SetCookie(CommonConstants.QueryParamsKeys.appUtmTerm, UTMSplitValue[5]);
            }
        }
    }
    private setproductCategoryCode(ProdName) {
        let productCategoryCodeL3;
        switch (ProdName) {
            case 'DDOL':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.ULSME;
                break;
            case 'DCAL':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.ULSME;
                break;
            case CommonConstants.productCategoryCode.SPPL: productCategoryCodeL3 = CommonConstants.productCategoryCode.SPPL;
                break;
            case 'SOL':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.UL;
                break;
            case 'DBOL':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.ULBOL;
                break;
            case 'DHL':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.DHL;
                break;
            case 'DHB':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.DHB;
                break;
            case 'DLAP':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.DLAP;
                break;
            case 'DLAPB':
                productCategoryCodeL3 = CommonConstants.productCategoryCode.DLAPB;
                break;
            default: break;
        }
        this._sharedService.setData(CommonConstants.SharedServiceDataKeys.productCategoryCode, productCategoryCodeL3);
    }

    private createupdateProductPayload(ProdName: any) {
        const _reqPayload = {};
        _reqPayload['loanProduct'] = ProdName;
        _reqPayload['oldLoanProduct'] = CommonConstants.productCategoryCode.SPPL;
        _reqPayload['applicantKey'] = this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicantId);
        _reqPayload['applicationKey'] = this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationId);
        _reqPayload['applicationApplicantKey'] = this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationApplicantId);

        return _reqPayload;
    }

    /* private updateProduct(ProdName: any) {
        let URL;
        const isEdit = true;
        const reqPayload = this.createupdateProductPayload(ProdName);
        this._offerService.productLaunch(reqPayload)
            .subscribe((response: any) => {
                if (this.flowType === CommonConstants.FLOW_TYPE.oldFlow) {
                    URL = ConfigService.getInstance().getConfigObject().APIURL.productLaunchOldSol;
                } else if (this.flowType === CommonConstants.FLOW_TYPE.newFlow) {
                    URL = ConfigService.getInstance().getConfigObject().APIURL.productLaunchNewSol;
                }
                window.location.href = (URL.replace('{0}', this._sharedService.getData(CommonConstants.QueryParamsKeys.offerId)).
                    replace('{1}', this._sharedService.getData(CommonConstants.QueryParamsKeys.mob)).
                    replace('{2}', this._sharedService.getData(CommonConstants.SharedServiceDataKeys.YMDob)).
                    replace('{3}', this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicantId)).
                    replace('{4}', this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationId)).
                    replace('{5}', this._sharedService.getData(CommonConstants.QueryParamsKeys.loanApplicationKey)).
                    replace('{6}', this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationApplicantId)).
                    replace('{7}', isEdit).
                    replace('{8}', this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmRefCode)).
                    replace('{9}', this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmSource)).
                    replace('{10}', this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmMedium)).
                    replace('{11}', this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmCampaign)).
                    replace('{12}', this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmTerm)).
                    replace('{13}', this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmContent)).
                    replace('{16}', this._sharedService.getData(CommonConstants.QueryParamsKeys.uci)).
                    replace('{14}', this.emailUTMParameter).
                    replace('{15}', this.emailUTMValue));
            });
    } */

    // this checks if user should be ab tested or not?
    private initProcess(callback: Function) {
        this._routeContextProvider.NavigateToView([CommonConstants.Routes.Login]);
    }
    private authenticateSystem(): void {
        const userClientId = this._homeService.GetClientIdForUser();
        this.setSecretKeyForClientId(userClientId);
    }
    private setSecretKeyForClientId(clientId: string): void {
        this._homeService.GetSecretKeyForBasedOnClientId(clientId).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.ClientId, clientId);
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.SecretKey,
                        responseData.payload.secretKey);
                this.setSystemAuthToken(responseData.payload.secretKey, clientId);
            }
        });
    }
    private setSystemAuthToken(secretKey: string, clientId: string): void {
        this._homeService.GetSystemAuthToken({
            secretKey,
            clientId
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                const tokenObj = responseData.payload.tokens[0];
                console.log('tokens::', tokenObj);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWTokenCO, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKeyCO, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardToken, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardTokenCO, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                this.initProcess((mtResponse) => {
                    if (!mtResponse.errorBean) {
                        this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
                    } else {
                        console.log('Error Occured on ', mtResponse.errorBean);
                    }
                });
            }
        });
    }
}
